<template>
  <div class="tw-grid-cols-12 tw-grid tw-border-2 tw-border-grey-mid tw-rounded-t-4xl tw-divide-x">
    <slot />
  </div>
</template>
